import { StoreService } from '@store/shared/store.service';
import { Observable } from 'rxjs';

import { FormSubmissionBaseSelectors } from './form-submission.selectors';

export type FormSubmissionFacadeEssentials<Payload> = {
  payload: Observable<Payload>;
  submissionInProgress: Observable<boolean>;
  isSubmitted: Observable<boolean>;
  submissionSucceeded: Observable<boolean>;
  submissionFailed: Observable<boolean>;
};

export type FormSubmissionDispatch<Payload> = {
  submit: (payload: Payload) => void;
};

export function getFacadeFromBaseSelectors<Payload>(
  selectors: FormSubmissionBaseSelectors<Payload>,
  storeService: StoreService,
): FormSubmissionFacadeEssentials<Payload> {
  return {
    payload: storeService.getState(selectors.formPayload),
    submissionInProgress: storeService.getState(
      selectors.formSubmissionInProgress,
    ),
    isSubmitted: storeService.getState(selectors.formIsSubmitted),
    submissionSucceeded: storeService.getState(
      selectors.formSubmissionSucceeded,
    ),
    submissionFailed: storeService.getState(selectors.formSubmissionFailed),
  };
}
